/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Docs} from 'components/layout';
import {getIntegrations} from 'api/get-integrations';
import {getExtensions} from 'api/get-extensions';
import {Warning, Tip, Info, WhitelistDetails} from 'ui';
export const title = "Create models with the table selector", description = "Create Hightouch models using the table selector which queries existing tables and views within your source.", lastUpdatedDate = new Date(1674000000000);
export async function getStaticProps() {
  const integrations = await getIntegrations();
  const extensions = await getExtensions();
  return {
    props: {
      ...integrations,
      extensions,
      meta: {
        title: "Create models with the table selector",
        description: "Create Hightouch models using the table selector which queries existing tables and views within your source.",
        lastUpdatedDate: "Wed Jan 18 2023 00:00:00 GMT+0000 (Coordinated Universal Time)",
        slug: null,
        type: null,
        icon: null,
        toc: []
      }
    },
    revalidate: 60
  };
}
const MDXLayout = ({children, ...props}) => _jsx(Docs, Object.assign({}, props, {
  children: children
}));
function MDXContent(props = {}) {
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, {})
  })) : _createMdxContent();
  function _createMdxContent() {
    const _components = Object.assign({
      p: "p",
      strong: "strong",
      img: "img",
      a: "a"
    }, _provideComponents(), props.components);
    return _jsxs(_Fragment, {
      children: [_jsx(_components.p, {
        children: "With the table selector modeling method, you can build Hightouch models using existing tables in your source without writing any SQL."
      }), "\n", _jsx(Tip, {
        children: _jsxs(_components.p, {
          children: ["The first time you use the table selector you may not see your tables populated. Click the ", _jsx(_components.strong, {
            children: "Refresh"
          }), " button to the left of the search bar and your tables should appear."]
        })
      }), "\n", _jsx(_components.p, {
        children: "Start by selecting the table or view that you want to use as your model."
      }), "\n", _jsxs(_components.p, {
        children: ["Before you can continue, you must click ", _jsx(_components.strong, {
          children: "Preview"
        }), " to see a preview of the data. By default, Hightouch limits the preview to the first 100 rows. Once you've confirmed that the preview contains the data you expect, click ", _jsx(_components.strong, {
          children: "Continue"
        }), "."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "models/create-model-preview-table.png",
          alt: "Model preview using the table selector"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["The last step for model setup is to enter a descriptive ", _jsx(_components.strong, {
          children: "Name"
        }), " and select the column to use as a ", _jsx(_components.a, {
          href: "/getting-started/concepts#unique-primary-key-requirement",
          children: _jsx(_components.strong, {
            children: "Primary key"
          })
        }), ". You can optionally select a ", _jsx(_components.a, {
          href: "/workspace-management/folders-filters#folders",
          children: "folder"
        }), " to move the model to."]
      }), "\n", _jsx(_components.p, {
        children: _jsx(_components.img, {
          src: "models/create-model-primary-key.png",
          alt: "Setting a model Name and Primary key in the Hightouch UI"
        })
      }), "\n", _jsxs(_components.p, {
        children: ["Click ", _jsx(_components.strong, {
          children: "Finish"
        }), " to complete your model setup."]
      })]
    });
  }
}
export default MDXContent;
